// extracted by mini-css-extract-plugin
export default {"fromTheBlogsContainer":"fromTheBlogs_fromTheBlogsContainer__pjNXU","fromTheBlogsWrapper":"fromTheBlogs_fromTheBlogsWrapper__8gQ+k"};